import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  toaster:{
    type: "error",
    message: "",
    show: false,
    timeout: 5000,
  }
};

export const utilSlice = createSlice({
  name: "util",
  initialState,
  reducers: {
    setToastMessage: (state, action) => {
      state.toaster = action.payload;
    }
  },
});
export const { setToastMessage } =
  utilSlice.actions;